import { render, staticRenderFns } from "./sociallogin.vue?vue&type=template&id=54d3ebfe"
import script from "./sociallogin.vue?vue&type=script&lang=js"
export * from "./sociallogin.vue?vue&type=script&lang=js"
import style0 from "./sociallogin.vue?vue&type=style&index=0&id=54d3ebfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports